import { render, staticRenderFns } from "./aboutme.vue?vue&type=template&id=aa5b8e9c&scoped=true"
import script from "./aboutme.vue?vue&type=script&lang=js"
export * from "./aboutme.vue?vue&type=script&lang=js"
import style0 from "./aboutme.vue?vue&type=style&index=0&id=aa5b8e9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5b8e9c",
  null
  
)

export default component.exports